import React from "react";
import Header from "../Header/Header.jsx";
import Banner from "../Banner/Banner.jsx";
import BillpayService from "../BillpayService/BillpayService.jsx";
import Body from "../Body/Body.jsx";
import Blog from "../Blog/Blog.jsx";
import Newsletter from "../Newsletter/Newsletter.jsx";
import Footer from "../Footer/Footer.jsx";

const Home = () => {
  return (
    <>
      <Header />
      <div className="client-page-container " translate="no">
        <Banner />
        <BillpayService />
        <Body />
        <Blog />
        <Newsletter />
      </div>

      <Footer />
    </>
  );
};

export default Home;
